<template>
    <div class="anchor-navigation-dropdown">
        <simple-btn :facets="['has-grid']" class="anchor-navigation-dropdown--btn" @click="toggleDropdown">
            <ui-icon size="medium" symbol="more"/>
        </simple-btn>
        <ul class="u-reset anchor-navigation-dropdown--list-wrapper" v-if="showDropdown" @mouseleave="closeDropdown">
            <li class="u-reset anchor-navigation-dropdown--list-item" v-for="(item, index) in items" :key="item.id">
                <a class="u-reset anchor-navigation-dropdown--list-item-link"
                        :class="bemAdd(index === activeItemIndex ? 'active' : 'base', 'list-item-link')"
                        :href="`#${item.hook}`">
                    {{ item.title }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import SimpleBtn from '../../../components/buttons/simple-btn/simple-btn';

    export default {
        components: { SimpleBtn, UiIcon },
        mixins: [bemMixin('anchor-navigation-dropdown')],
        props: {
            items: {
                type: Array,
                default() {
                    return {
                        default: [],
                    };
                },
            },
            activeItemIndex: {
                type: Number,
                default() {
                    return {
                        default: null,
                    };
                },
            },
        },
        data() {
            return {
                showDropdown: false,
            };
        },
        methods: {
            toggleDropdown() {
                this.showDropdown = !this.showDropdown;
            },
            closeDropdown() {
                this.showDropdown = false;
            },
        },
    };
</script>
